import moment from 'moment';
import 'moment-duration-format';
import React, {useEffect, useState} from 'react';

export interface TimerProps {
  currentTime: any;
  startingTime?: string;
  endingTime: string;
  maxDurationInHours?: number;
  finishByHuman?: boolean;
  updateFinishedTimer?: () => void;
  onFinishTimer?: () => void;
  finishedTimer?: boolean;
}

const Timer: React.FC<TimerProps> = ({
  currentTime,
  endingTime,
  finishByHuman = false,
  maxDurationInHours = null,
  startingTime = null,
  updateFinishedTimer = () => {},
  onFinishTimer = () => {},
  finishedTimer,
}) => {
  const [timer, setTimer] = useState<number | null>(null);
  const [format, setFormat] = useState('D[d] h[h] m[m]');
  const oneMinute = moment.duration(1, 'm').asMilliseconds();

  const handleFinishedTimer = () => {
    updateFinishedTimer();
    onFinishTimer();
    setFormat('s[s]');
    setTimer(0);
  };

  useEffect(() => {
    const remainingTime = moment(endingTime).diff(
      moment(currentTime),
      'hours',
      true,
    );

    if (!maxDurationInHours) return setTimer(remainingTime);

    const elapsedTime = moment(currentTime).diff(
      moment(startingTime),
      'hours',
      true,
    );

    const remainingDuration = maxDurationInHours - elapsedTime;

    if (remainingTime <= 0 || remainingDuration <= 0) {
      return handleFinishedTimer();
    }

    const endingDuration = moment(currentTime)
      .add(maxDurationInHours, 'h')
      .format();

    if (moment(endingDuration).isBefore(endingTime)) {
      setTimer(remainingDuration);
    } else {
      setTimer(remainingTime);
    }
  }, [currentTime, endingTime]);

  useEffect(() => {
    const id: any = setInterval(() => {
      if (finishByHuman || finishedTimer) return clearInterval(id);

      updateTimer(id);
    }, 1000);

    return () => clearInterval(id);
  }, [timer]);

  const updateTimer = (intervalId: number) => {
    const duration = moment.duration(timer, 'h').subtract(1, 'second');

    const ms = duration.asMilliseconds();

    if (ms < oneMinute) {
      setFormat('s[s]');
    }

    if (ms <= 0) {
      handleFinishedTimer();
      return clearInterval(intervalId);
    }

    setTimer(duration.asHours());
  };

  return (
    <span data-id="timer" className="test-timer">
      {moment.duration(timer, 'h').format(format)}
    </span>
  );
};

export default Timer;
